(function(){
    
  	// data
      let data = {
        widgets: []
      }
    
    // widget setup
    
      let current_widget_number = 0;
      let current_widget = data['widgets'][current_widget_number];

      // rule functions 
      function evaluate_number(input,operator_symbol,target_value){

        if(input == 'product_price'){
          // evaluate product prices (more than 1 number)
          results = BoostUpSell.cart_data[input].map((price) => {
            var condition = `${parseInt(price, 10)} ${operator_symbol} ${target_value}`;
            var evaluate = (c) => Function(`return ${c}`)();

            if(evaluate(condition)) {
              return true;
            }else{
              return false;
            }    

          });

          if (results.indexOf(true) != '-1'){
            return true;
          }else{
              return false;
          }

        }else{
          // evaluate any single number
          var condition = `${BoostUpSell.cart_data[input]} ${operator_symbol} ${target_value}`;
          var evaluate = (c) => Function(`return ${c}`)();

          if(evaluate(condition)) {
            return true;
          }else{
            return false;
          }
        }
      }

      function evaluate_string(input,operator_symbol,target_value){
        // string contains value
        if(operator_symbol == '-'){
          if(BoostUpSell.cart_data[input].includes(target_value.toLowerCase())){
           return true;
          }else{
            return false;
          }
        }else{
          // string does not contain value
          if(BoostUpSell.cart_data[input].toLowerCase().indexOf(target_value.toLowerCase()) === -1){
            return true;
          }else{
            return false;
          }
        }
      }

      function processRule(rule) {
        if (rule.type == 'number'){
          return evaluate_number(rule['input'],rule['operator_symbol'],rule['target_value'])
        }else{
         return evaluate_string(rule['input'],rule['operator_symbol'],rule['target_value'])
        }
      }

      function generate_widget(){
        document.getElementById('boost-heading').textContent = current_widget['heading'];
        document.getElementById('boost-sub-heading').textContent = current_widget['sub_heading'];
        document.getElementById('boost-price').textContent = current_widget['currency_symbol'] + current_widget['price'];
        if(current_widget['compare_at_price'] == '' || '0.00' || '0'){
          document.getElementById('boost-compare-at-price').textContent = ''
        }else{
          document.getElementById('boost-compare-at-price').textContent = current_widget['currency_symbol'] + current_widget['compare_at_price'];
        }
        document.getElementById('boost-btn').textContent = current_widget['button_text'];
        document.getElementById('boost-product-img').src = current_widget['image'];
        document.getElementById('boost-container').style.display = 'flex';
      }

      function evaluate_rules(){
        if(current_widget['rules'][0]){
          let results = current_widget['rules'].map(processRule);
          let all_required_to_pass = true

          if (all_required_to_pass){
            if (results.indexOf(false) == '-1'){
              generate_widget();
            }
          }else{
            if (results.indexOf(true) != '-1'){
              generate_widget();
            }
          }
        }else{
          generate_widget();
        }
      }
    
    // analytics / add to cart logic
      
      function API(url) {
        var xhr = new XMLHttpRequest();
        if (!('withCredentials' in xhr)) xhr = new XDomainRequest(); // fix IE8/9
        xhr.open('POST', url);
        xhr.send();
        return xhr;
      }
        
      document.getElementById('boost-btn').addEventListener('click', function() {

        let shop = BoostUpSell.shop
        let token = 'test_token'

        let items = { }
        items[current_widget['variant_id']] = 1
        
        // fixes buy button issue
        if(BoostUpSell.cart_data['line_item_count'] == 1){
          items[parseInt(BoostUpSell.cart_data['buy_now_product_id'])] = parseInt(BoostUpSell.cart_data['buy_now_product_quantity']);
        }
        
        let http = new XMLHttpRequest();
        let url = '/cart/update.js';
        let params = JSON.stringify({
          attributes: { 'order_has_addon': current_widget['variant_id'] },
          updates: items
        });
        http.open('POST', url, true);
        http.setRequestHeader('Content-type', 'application/json; charset=utf-8', false);
        http.onreadystatechange = function() {
          if(http.readyState == 4 && http.status == 200) {
            /// fire off api call to count clicks
            API('https://app.boostupsell.com/api/track?token=' + token + '&shop=' + shop + '&variant_id=' + current_widget['variant_id']);
            window.location.replace('/checkout');
          }
        }
        http.send(params);
    
      }, false);
        
      if(Shopify.Checkout.OrderStatus == undefined){
         if(current_widget && Shopify.Checkout.step == 'contact_information'){
          evaluate_rules();
        }
      }
  
})();